import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { mobile_xl } from '../../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../../../global/commonStyle';

interface TaskButtonProps {
  isHide?: boolean;
}

const Container = styled.div`
  position: sticky;
  top: 0;
  ${FlexBetween}
  padding: var(--space-10) var(--space-24);
  background-color: var(--background-secondary);
  z-index: var(--z-index-999);
  border-bottom: 0.5px solid var(--border-primary);
`;

const Content = styled.div`
  ${AlignCenter}
  gap: var(--space-24);
`;

const Title = styled.h1`
  ${Typography.heading_md}
  color:var(--text-primary);
  margin: var(--space-0);
`;

const ButtonBlock = styled.div`
  display: flex;
  gap: var(--space-5);
  cursor: pointer;
  ${mobile_xl(css`
    padding: var(--space-8) var(--space-20) var(--space-6);
    display: flex;
    gap: var(--space-8);
    background-color: var(--background-secondary);
  `)}
`;

const TaskIcons = styled.div`
  display: flex;
  gap: var(--space-12);
  height: 26px;
  ${mobile_xl(css`
    align-items: center;
    .hide-button {
      display: none;
    }
    .responsive-button {
      height: 26px;
    }
  `)}
`;

const Filter = styled.div<TaskButtonProps>`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-8) var(--space-5) var(--space-10);
  background: var(--background-primary);
  border-radius: var(--border-radius-8);
  box-shadow: var(--border);
  &:hover {
    background-color: var(--background-secondary);
    box-shadow: var(--button-border-hover);
  }
  .filters-icon-color {
    fill: var(--text-secondary);
  }
  ${(props: TaskButtonProps) =>
    props.isHide &&
    css`
      border: none;
      background: none;
      box-shadow: none;
      padding: var(--space-8);
      &:hover {
        background: var(--neutral-secondary);
        border-radius: var(--border-radius-12);
      }
    `}
  ${mobile_xl(css`
    background: unset;
    padding: var(--space-8);
    border: none;
    box-shadow: unset;
    &:hover {
      box-shadow: unset;
    }
  `)}
`;

const SelectText = styled.div<TaskButtonProps>`
  ${Typography.body_sm_medium}
  color:var(--text-primary);
  margin: var(--space-0);
  ${(props: TaskButtonProps) =>
    props.isHide &&
    css`
      display: none;
    `}
  ${mobile_xl(css`
    display: none;
  `)}
`;

const Div = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  ${mobile_xl(css`
    background-color: var(--background-primary);
    padding: var(--space-12) var(--space-16);
    border-bottom: 0.5px solid var(--border-primary);
    width: 100%;
  `)}
`;
export { Container, Content, Title, ButtonBlock, TaskIcons, Filter, SelectText, Div };
